/**
 * Formats an entity reference for display using the uid field.
 *
 * The entity service builds the uid from displayable attributes in
 * template order (e.g. "Location Name,DUNS"). We use the uid directly
 * rather than the raw attributes map, which has no guaranteed key order
 * and includes non-display fields like geoJson.
 *
 * When the uid is a comma-separated composite, the first value is the
 * primary name and subsequent values are shown in parentheses.
 */
export const formatEntityDisplayLabel = (
    option: { uid?: string } | null | undefined,
): string => {
    const uid = option?.uid || ''
    const commaIndex = uid.indexOf(',')
    if (commaIndex > 0) {
        const name = uid.substring(0, commaIndex)
        const rest = uid.substring(commaIndex + 1)
        if (rest) {
            return `${name} (${rest})`
        }
    }
    return uid
}
